import { Panel } from 'primereact/panel';
import { ContractDraftAttachment } from '../../../../Interfaces/Accounting/ACForms.interfaces';

type ContractAttachmentsSummaryProps = {
  attachments?: ContractDraftAttachment[];
};

const ContractAttachmentsSummary = ({
  attachments,
}: ContractAttachmentsSummaryProps) => {
  return (
    <Panel header="Attachments" className="max-w-600px mx-3 text-standard">
      <div className="grid prevent-break-children">
        {attachments && attachments?.length > 0
          ? attachments.map((file) => {
              return (
                <div key={file.uniqueName} className="col-12">
                  {file.name}
                </div>
              );
            })
          : 'No attachments were provided.'}
        <div className="col-12"></div>
      </div>
    </Panel>
  );
};

export default ContractAttachmentsSummary;
